// @flow

import React, { type Node, useEffect } from 'react';
import { usePayment } from '../context';
import { useAssertionOptions } from '../hooks/use-assertion-options';
import { useWebAuthnAssertion } from '../hooks/use-webauthn-assertion';
import { usePaymentAuthentication } from '../hooks/use-payment-authentication';
import { SpinnerContainer, Spinner } from './loading-screen.styles';

export function LoadingScreen(): Node {
  const { data, dispatch } = usePayment();
  const performAssertion = useWebAuthnAssertion();
  const submitAuthentication = usePaymentAuthentication();

  useAssertionOptions();

  useEffect(() => {
    if (data.state !== 'AUTHENTICATING') return;

    let cancelled = false;

    async function runAssertion() {
      try {
        const assertionData = await performAssertion();
        if (cancelled || !assertionData) return;
        await submitAuthentication(assertionData);
      } catch (err) {
        if (!cancelled) {
          dispatch({ type: 'SET_ERROR', errorMessage: err.message || 'Erro na autenticação. Tente novamente.' });
        }
      }
    }

    runAssertion();

    return () => {
      cancelled = true;
    };
  }, [data.state, performAssertion, submitAuthentication, dispatch]);

  return (
    <SpinnerContainer>
      <Spinner />
    </SpinnerContainer>
  );
}
